import { routes } from "@/constants/routes";
import { Redirect } from "expo-router";

export default function TenantAnimalDetailRedirect() {
  return <Redirect href={routes.myAnimals} />;
}
